import Avatar from "../../../assets/Avatar.png";
import ClockIcon from "../../Icons/ClockIcon";
import PersonIcon from "../../Icons/PersonIcon";
import CoursePlaceholder from "../../../assets/CoursePlaceholder.png";
import { CoursesDTO } from "../../../api/Courses/GetAllCourses";
import ThreeDotsIcon from "../../Icons/ThreeDotsIcon";
import CourseDropdown from "./CourseDropdown";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUserCountry } from "../../../utils/utils";
import ReactMarkdown from "react-markdown";
interface CourseCardProps {
  course: CoursesDTO;
  refetchCoursesRevision?: () => void;
}

const CourseCard = ({ course, refetchCoursesRevision }: CourseCardProps) => {
  const [showFullDescription] = useState(false);
  const descriptionWords = course.description.split(" ");

  const truncatedDescription = showFullDescription
    ? descriptionWords.join(" ")
    : descriptionWords.slice(0, 22).join(" ");
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    const userCountry = getUserCountry();
    setCountry(userCountry);
  }, []);

  return (
    <div className="group relative flex w-full flex-col justify-between overflow-visible rounded-2xl border border-black/10 bg-white p-4 shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_55px_rgba(17,24,22,0.12)]">
      <div className="relative mb-4">
        <Link
          to={`/course/${course.slug}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="aspect-[4/3] w-full rounded-xl border border-black/5 object-cover transition duration-300 group-hover:scale-[1.015]"
            src={course.img_url || CoursePlaceholder}
            alt="Course"
          />
        </Link>
        {course.part && (
          <div className="absolute w-16 h-7 text-white bg-primary top-[26px] left-px rounded-tr rounded-br flex justify-center items-center">
            Part {course.part}
          </div>
        )}
      </div>
      <div>
        <div className="flex justify-between w-full items-center mb-3 py-0.5">
          <h1 className="min-w-0 text-xl font-bold text-textPrimary">{course.name}</h1>
          <div className="flex min-w-[90px] items-center justify-center gap-0.5 rounded-xl bg-primary px-3 py-1.5 font-bold text-white">
            {country === "EG" ? (
              <>
                {" "}
                {course.actualPrice_egp}{" "}
                <span className="text-sm uppercase">EGP</span>
              </>
            ) : (
              <>
                {course.actualPrice_usd}{" "}
                <span className="text-sm uppercase">USD</span>
              </>
            )}
          </div>
        </div>
        <div className=" mb-4">
          <span className="text-sm font-medium text-lightGray">
            <ReactMarkdown>{truncatedDescription}</ReactMarkdown>
          </span>
          {!showFullDescription && (
            <Link
              className="text-sm font-bold text-primary"
              to={
                course.slug
                  ? `/offline-course/${course.id}`
                  : `/course/${course.slug}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              &nbsp; Learn more about {course.name}
            </Link>
          )}
        </div>
        <div className="flex gap-2 items-center mb-4">
          <img
            src={course?.Instructor?.photo || Avatar}
            className="max-w-5 max-h-5 w-full h-full object-cover rounded-full object-[75%_25%]"
            alt="Instructor Avatar"
          />
          <h1 className="text-xs font-medium text-textPrimary">
            {course?.Instructor?.firstName} {course?.Instructor?.lastName}{" "}
            <span className="opacity-70">from</span> {course?.Instructor?.city},{" "}
            {course?.Instructor?.country}
          </h1>
        </div>
        <div className="flex gap-2.5 mb-2">
          <ClockIcon />
          <span className="text-xs text-lightGray">
            {course?.num_hours} hours
          </span>
        </div>
        <div className="flex gap-2.5">
          <PersonIcon />
          <span className="text-xs text-lightGray">
            {course?._count?.students} students
          </span>
        </div>
        <div className="absolute bottom-4 right-4 z-10">
          <CourseDropdown
            slug={course.slug}
            courseId={course.id}
            refetchCoursesRevision={refetchCoursesRevision}
          >
            <ThreeDotsIcon />
          </CourseDropdown>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
